import { PagedQuestionnaireWrapper } from 'features/patient/assessment/_components/questionnaire-paginator';
import { QUESTIONNAIRE_TITLE_24_HR } from '../../_components/questionnaire-paginator-types';
import {
  initialState,
  PcsInventory,
  PcsSliceReducer,
  submit,
  updatePcsItem,
  validate
} from './pcsSlice';
import { formatQuestionnaireData } from '../cgs/cgs-pagination-combined';
import { PcsQuestionnaire } from 'features/patient/_utils/questionnaires';

export function PaginationCombined(props: { storageKey: string }) {
  return (
    <PagedQuestionnaireWrapper
      pageTitle={QUESTIONNAIRE_TITLE_24_HR}
      actions={{
        formatData: formatPcs,
        validate,
        updateItem: updatePcsItem,
        submit
      }}
      getData={state => state.pcs}
      initialState={initialState}
      storageKey={props.storageKey}
      reducer={PcsSliceReducer}
    />
  );
}

/**
 * purpose is to standardize `paginationCombined` data intake;
 * @param pcsData
 * @param pageLimit
 * @returns
 */
function formatPcs(pcsData: PcsInventory, pageLimit: number) {
  return formatQuestionnaireData(PcsQuestionnaire, pcsData, pageLimit);
}
